import { Injectable, TemplateRef } from "@angular/core";
import { environment } from "../../environments/environment";

/**
 * Shared stateless helpers used by both FrontDeskComponent and
 * TechnicianComponent. These are pure functions with no dependency on
 * component instance state, so they are safe to centralise here.
 */
@Injectable({
  providedIn: "root",
})
export class FrontDeskSharedService {
  getMonthStr(value): string {
    if (value) {
      let flag = "";
      switch (value) {
        case 1:
          flag = "Jan";
          break;
        case 2:
          flag = "Feb";
          break;
        case 3:
          flag = "Mar";
          break;
        case 4:
          flag = "Apr";
          break;
        case 5:
          flag = "May";
          break;
        case 6:
          flag = "Jun";
          break;
        case 7:
          flag = "Jul";
          break;
        case 8:
          flag = "Aug";
          break;
        case 9:
          flag = "Sep";
          break;
        case 10:
          flag = "Oct";
          break;
        case 11:
          flag = "Nov";
          break;
        case 12:
          flag = "Dec";
          break;
        default:
          flag = "";
          break;
      }
      return flag;
    }
  }

  getMonthNumber(value) {
    if (value) {
      let flag = 0;
      switch (value.toString().toLowerCase()) {
        case "jan":
          flag = 1;
          break;
        case "feb":
          flag = 2;
          break;
        case "mar":
          flag = 3;
          break;
        case "apr":
          flag = 4;
          break;
        case "may":
          flag = 5;
          break;
        case "jun":
          flag = 6;
          break;
        case "jul":
          flag = 7;
          break;
        case "aug":
          flag = 8;
          break;
        case "sep":
          flag = 9;
          break;
        case "oct":
          flag = 10;
          break;
        case "nov":
          flag = 11;
          break;
        case "dec":
          flag = 12;
          break;
        default:
          flag = 0;
          break;
      }
      return flag;
    }
  }

  checkMonthValidation(ctx: any, frommonthstr, tomonthstr): boolean {
    const frommonth = ctx.getMonthNumber(
      frommonthstr.charAt(0).toUpperCase() + frommonthstr.slice(1)
    );
    const tomonth = ctx.getMonthNumber(
      tomonthstr.charAt(0).toUpperCase() + tomonthstr.slice(1)
    );

    let flag = false;
    if (frommonth && tomonth) {
      if (frommonth > tomonth) {
        flag = false;
      } else {
        flag = true;
      }
    } else {
      flag = false;
    }
    return flag;
  }

  getLanguage(ctx: any) {
    ctx.appservice.getlang().subscribe((res) => {
      if (res["validationMessage"])
        ctx.validationMessage = res["validationMessage"];
      ctx.techmessage = res["techInfo"];
    });
  }

  yearValidation(ctx: any, value): number {
    let year = 0;
    if (value) {
      if (+value <= ctx.today.getFullYear()) {
        year = value;
      }
    }
    return year;
  }

  monthValidation(ctx: any, value): number {
    let month = 0;
    if (value) {
      if (+value <= 12 && +value > 0) {
        month = value;
      }
    }
    return month;
  }

  dayValidation(ctx: any, value, totalday): number {
    let day = 0;
    if (value) {
      if (value <= totalday && value > 0) {
        day = value;
      }
    }
    return day;
  }

  checkTotalDaycount(ctx: any, month): number {
    switch (month) {
      case "01":
        return 31;
        break;
      case "02":
        return 28;
        break;
      case "03":
        return 31;
        break;
      case "04":
        return 30;
        break;
      case "05":
        return 31;
        break;
      case "06":
        return 30;
        break;
      case "07":
        return 31;
        break;
      case "08":
        return 31;
        break;
      case "09":
        return 30;
        break;
      case "10":
        return 31;
        break;
      case "11":
        return 30;
        break;
      case "12":
        return 31;
        break;
      default:
        return 0;
        break;
    }
  }

  downloadDoc(ctx: any, key) {
    if (key) {
      window.location.href = environment.cloudFrontURL + key;
    }
  }

  personalEmailInput(ctx: any, value) {
    ctx.checkPersonalEmailValidationMessage(value);
  }

  openModal(ctx: any, template: TemplateRef<any>) {
    ctx.modalRef = ctx.modalService.show(
      template,
      Object.assign(ctx.config, { class: "popup-center" })
    );
  }

  getMobileMask(ctx: any, code, telNumber): string {
    let flag = "-";
    if (code && telNumber) {
      if (code == "+91") {
        flag =
          code +
          " " +
          telNumber.substring(0, 5) +
          "-" +
          telNumber.substring(5, 10);
      } else if (code == "+1") {
        flag =
          code +
          " (" +
          telNumber.substring(0, 3) +
          ") " +
          telNumber.substring(3, 6) +
          "-" +
          telNumber.substring(6, 10);
      }
    }
    return flag;
  }

  roundprocessvalue(ctx: any, value): number {
    return Math.floor(value);
  }

  getcountry(ctx: any) {
    ctx.appservice.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          ctx.countryList = res["entity"];
        } else {
          ctx.countryList = [];
        }
      },
      (err) => {
        ctx.appservice.sessionOut(err);
      }
    );
  }

}
